var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',_vm._g(_vm._b({staticClass:"disaprove-button",attrs:{"round":""}},'el-button',_vm.$attrs,false),_vm.$listeners),[_c('i',{staticClass:"fas fa-times"}),_vm._v(" Desaprovar\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }